/**
 * Common error codes used by wrappers
 * @readonly
 * @enum {string}
 */
export const ERROR_CODES = {
	ETIMEDOUT: 'ETIMEDOUT',
	ECONNRESET: 'ECONNRESET',
	ENOTFOUND: 'ENOTFOUND',
	ECONNREFUSED: 'ECONNREFUSED',
	EOPENBREAKER: 'EOPENBREAKER',
};

/**
 * Common error names used by wrappers
 * @readonly
 * @enum {string}
 */
export const ERROR_NAMES = {
	TIMEOUT_ERROR: 'TimeoutError',
	ABORT_ERROR: 'AbortError',
	FETCH_ERROR: 'FetchError',
};

/**
 * Circuit breaker states
 * @readonly
 * @enum {string}
 */
export const CIRCUIT_BREAKER_STATES = {
	OPEN: 'OPEN',
	CLOSED: 'CLOSED',
	HALF_OPEN: 'HALF_OPEN',
	UNKNOWN: 'UNKNOWN',
};

/**
 * HTTP status codes used by fetch wrapper
 * @readonly
 * @enum {number}
 */
export const HTTP_STATUS = {
	NO_CONTENT: 204,
	TOO_MANY_REQUESTS: 429,
	SERVER_ERROR_MIN: 500,
};

/**
 * Default options for all wrappers
 * @typedef {Object} DefaultOptionsType
 * @property {Object} RETRY - Default retry options (retries: 1, minTimeout: 30ms)
 * @property {Object} CIRCUIT_BREAKER - Default circuit breaker options (timeout: 1800ms, volumeThreshold: 20)
 * @property {Object} TIMEOUT - Default timeout options (timeout: 600ms)
 * @property {Object} FETCH - Default fetch options (responseBodyType: 'json')
 * @property {Object} NEW_RELIC - Default New Relic options
 */
export const DEFAULT_OPTIONS = {
	RETRY: {
		retries: 1,
		minTimeout: 30,
	},
	CIRCUIT_BREAKER: {
		timeout: 1800,
		volumeThreshold: 20,
	},
	TIMEOUT: {
		timeout: 600,
	},
	FETCH: {
		responseBodyType: 'json',
	},
	NEW_RELIC: {},
};
